(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // START: Code for hover-to-open desktop menu
  function initHeaderMenuHover() {
    if (window.matchMedia('(min-width: 990px)').matches) {
      const menuDetails = document.querySelectorAll('.header__inline-menu details.mega-menu');

      menuDetails.forEach(details => {
        const parentLi = details.closest('li');
        if (!parentLi) return;

        parentLi.addEventListener('mouseenter', () => {
          details.setAttribute('open', '');
        });

        parentLi.addEventListener('mouseleave', () => {
          details.removeAttribute('open');
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initHeaderMenuHover);
  document.addEventListener('shopify:section:load', initHeaderMenuHover);
  // END: Code for hover-to-open desktop menu
  
  // Mega Menu Image Slider functionality
function initMegaMenuSlider() {
  if (window.matchMedia('(min-width: 990px)').matches) {
    const megaMenus = document.querySelectorAll('.mega-menu__content');
    
    megaMenus.forEach(menu => {
      const menuList = menu.querySelector('.mega-menu__list');
      if (!menuList) return;
      
      // Get all menu image items
      const imageItems = Array.from(menuList.querySelectorAll('.mega_menu_img'));
      
      // Only create slider if there are more than 4 images
      if (imageItems.length > 4) {
        // Mark the menu list as having a slider
        menuList.classList.add('has-mega-slider');
        
        // Create slider wrapper around existing images
        const sliderWrapper = document.createElement('div');
        sliderWrapper.className = 'mega-menu-slider-wrapper has-slider';
        
        // Create slider container
        const sliderContainer = document.createElement('div');
        sliderContainer.className = 'mega-menu-slider-container';
        
        // Get the parent of the first image item
        const firstImage = imageItems[0];
        const parentList = firstImage.parentElement;
        
        // Insert wrapper before first image
        parentList.insertBefore(sliderWrapper, firstImage);
        
        // Move all image items into slider container
        imageItems.forEach(item => {
          sliderContainer.appendChild(item);
        });
        
        // Add container to wrapper
        sliderWrapper.appendChild(sliderContainer);
        
        // Create left arrow button
        const leftArrow = document.createElement('button');
        leftArrow.className = 'mega-menu-slider-arrow mega-menu-slider-arrow--left';
        leftArrow.setAttribute('aria-label', 'Scroll left');
        leftArrow.innerHTML = `
          <svg viewBox="0 0 24 24">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        `;
        
        // Create right arrow button
        const rightArrow = document.createElement('button');
        rightArrow.className = 'mega-menu-slider-arrow mega-menu-slider-arrow--right';
        rightArrow.setAttribute('aria-label', 'Scroll right');
        rightArrow.innerHTML = `
          <svg viewBox="0 0 24 24">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        `;
        
        sliderWrapper.appendChild(leftArrow);
        sliderWrapper.appendChild(rightArrow);
        
        // Scroll functionality
        let currentIndex = 0;
        const maxIndex = Math.max(0, imageItems.length - 4);
        
        function updateSlider() {
          const itemWidth = sliderContainer.querySelector('.mega_menu_img').offsetWidth;
          const gap = 20;
          const scrollAmount = currentIndex * (itemWidth + gap);
          sliderContainer.style.transform = `translateX(-${scrollAmount}px)`;
          
          // Update arrow states
          if (currentIndex === 0) {
            leftArrow.classList.add('disabled');
          } else {
            leftArrow.classList.remove('disabled');
          }
          
          if (currentIndex >= maxIndex) {
            rightArrow.classList.add('disabled');
          } else {
            rightArrow.classList.remove('disabled');
          }
        }
        
        rightArrow.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          if (currentIndex < maxIndex) {
            currentIndex++;
            updateSlider();
          }
        });
        
        leftArrow.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          if (currentIndex > 0) {
            currentIndex--;
            updateSlider();
          }
        });
        
        // Reset scroll when menu closes
        const details = menu.closest('details');
        if (details) {
          details.addEventListener('toggle', () => {
            if (!details.open) {
              currentIndex = 0;
              updateSlider();
            }
          });
        }
        
        // Initial update
        updateSlider();
        
        // Update on window resize
        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            if (window.matchMedia('(min-width: 990px)').matches) {
              updateSlider();
            }
          }, 250);
        });
      }
    });
  }
}

// Initialize on load and section reload
document.addEventListener('DOMContentLoaded', initMegaMenuSlider);
document.addEventListener('shopify:section:load', initMegaMenuSlider);

  } catch(e) { console.error(e); }
})();
})();
